import React, { useEffect, useState } from 'react';

// bootstrap
import { Col, Row } from "react-bootstrap";

// tremor
import { Subtitle } from "@tremor/react";

// drop down menu
import Select from "react-select";

// styling
import { Spacing } from "_styles";

// redux
import { selectSelectedTimeline, selectDropOffLocations, selectPickUpLocations } from "_redux/slices/timeline/timeline-areas";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { selectSelectedTasksList, selectSelectedTask, setSelectedTaskList, setSelectedTask, selectSelectedMultiplePAXTask, } from "_redux/slices/timeline/selected-task";
import { selectDefaultCheckInLocation } from "_redux/slices/timeline/timeline-control";
import { selectFirebaseInfo } from "_redux/slices/main-screen/user";
import { selectFlightListIndexed } from '_redux/slices/timeline/flight-information-list';
import { selectUsedTheme } from '_redux/slices/timeline/theme';

const PickupDropOffDropDowns = (props) => {

    // local states
    const [flightNumber, setFlightNumber] = useState("");
    const [flightDoc, setFlightDoc] = useState(null);

    // redux
    const dropOffLocations = useSelector(selectDropOffLocations);                 // airport drop off locations
    const pickUpLocations = useSelector(selectPickUpLocations);                   // airport pick up locations
    const selectedTask = useSelector(selectSelectedTask);                         // selected task from the job list
    const selectedMultiplePAXTask = useSelector(selectSelectedMultiplePAXTask);   // selected task with multiple pax from the job list

    const defaultCheckInLocation = useSelector(selectDefaultCheckInLocation)      // default check in location from the timeline data
    const flightList = useSelector(selectFlightListIndexed)                       // list of flights from flight list
    const usedTheme = useSelector(selectUsedTheme);

    // airport
    const dbUser = useSelector(selectFirebaseInfo);
    const iata = dbUser?.details?.authority;

    // set pick up + drop off location
    useEffect(() => {
        let wantedFlightNumber = "";
        if (!Object.isObjectEmpty(selectedTask)) {
            // try and find matching flight for pax
            if (selectedTask?.flightConfirmationDetails) {
                wantedFlightNumber = selectedTask?.flightConfirmationDetails?.carrierCode + selectedTask?.flightConfirmationDetails?.flightNumber;
            }
            if (selectedTask?.flightInformation) {
                wantedFlightNumber = selectedTask?.flightInformation?.flightNumber;
            }
        } else if (!Object.isObjectEmpty(selectedMultiplePAXTask)) {
            wantedFlightNumber = selectedMultiplePAXTask?.[0]?.flightConfirmationDetails?.carrierCode + selectedMultiplePAXTask?.[0]?.flightConfirmationDetails?.flightNumber;
        } else {
            wantedFlightNumber = "";
        }

        setFlightNumber(wantedFlightNumber);

    }, [selectedTask, selectedMultiplePAXTask]);

    useEffect(() => {
        // check flight number
        if (flightNumber != "") {

            // check flight list is valid
            if (flightList && Object.keys(flightList) && Object.keys(flightList).length > 0) {

                // code switch if required
                let tempNumber = flightNumber;

                if (tempNumber?.includes('EZY')) {
                    // need to replace 'EZY' with 'U2'
                    tempNumber = tempNumber?.replace('EZY', 'U2');
                }

                let origin = "";
                let destination = ""
                let wantedTask = null;
                if (!Object.isObjectEmpty(selectedTask)) {
                    wantedTask = selectedTask;
                } else if (!Object.isObjectEmpty(selectedMultiplePAXTask)) {
                    wantedTask = selectedMultiplePAXTask?.[0];
                }
                if (wantedTask?.flightConfirmationDetails) {
                    origin = wantedTask?.flightConfirmationDetails?.origin;
                    destination = wantedTask?.flightConfirmationDetails?.destination;
                } else if (wantedTask?.flightInformation) {
                    origin = wantedTask?.flightInformation?.departureAirport;
                    destination = wantedTask?.flightInformation?.arrivalAirport;
                }

                // try find our flight
                let flightDocument = flightList[`${tempNumber}_${origin}_${destination}`];

                if (flightDocument != undefined) {
                    // set flight doc
                    setFlightDoc(flightDocument)
                }
                else {
                    // no flight exists for this booking
                    setFlightDoc(null)
                }
            }
        }
    }, [flightNumber, flightList, selectedTask, selectedMultiplePAXTask]);

    useEffect(() => {
        // check if there is a flight doc
        if (flightDoc != null) {

            // try get gate / stand from flight doc
            let flightGate = flightDoc?.gate;
            let flightStand = flightDoc?.stand;
            let flightType = flightDoc?.type;

            let pickup = ''
            let dropoff = ''

            if (flightType == 'arrival') {
                // need to set pickup locaiton based on stand / gate
                // try find corresponding location for gate / stand
                pickup = matchLocationByGateOrStand(pickUpLocations, flightGate, flightStand);
            }
            else if (flightType == 'departure') {
                // need to set dropoff location based on stand / gate
                // try find corresponding location for gate / stand
                dropoff = matchLocationByGateOrStand(dropOffLocations, flightGate, flightStand);

                // check if passenger has checked in 
                if (selectedTask?.combinedBooking) {
                    pickup = matchLocationByGateOrStand(pickUpLocations, flightGate, flightStand);
                } else if (selectedTask?.paxPositionInfo?.activity === "Checked-in") {
                    // get checkin locaiton
                    let checkinLocation = selectedTask?.paxPositionInfo?.locationId;
                    // try find corresponding location for gate / stand
                    pickup = pickUpLocations?.find(loc => loc?._id === checkinLocation);
                } else if (selectedTask?.isALTPickUp || selectedTask?.isGateRelocation) {
                    // Handle ALT pickup and gate relocation tasks
                    if (selectedTask?.pickUpLocation?.id) {
                        pickup = matchLocationById(pickUpLocations, selectedTask?.pickUpLocation?.id)
                    };
                    if (selectedTask?.dropOffLocation?.id) {
                        dropoff = matchLocationById(dropOffLocations, selectedTask?.dropOffLocation?.id)
                    }
                } else {

                    // check if pax has location (like alt pickup)
                    if (selectedTask?.paxPositionInfo?.locationId) {
                        // try find corresponding location for gate / stand
                        pickup = matchLocationByGateOrStand(pickUpLocations, selectedTask?.paxPositionInfo?.locationId);
                    } else {
                        // no location set
                        if (defaultCheckInLocation) {
                            // use default checkin location
                            pickup = pickUpLocations?.find(loc => loc?._id === defaultCheckInLocation);
                        }
                        else {
                            pickup = null
                        }
                    }

                }
            }

            // set states using pickup / dropoff
            if (pickup) {
                props.setSelectedPickUp(pickup?._id);
            } else {
                props.setSelectedPickUp(null);
            }
            if (dropoff) {
                props.setSelectedDropOff(dropoff?._id);
            } else {
                props.setSelectedDropOff(null);
            }

        } else {
            // No flight document - check if this is a gate relocation or ALT pickup task with location data
            if (selectedTask?.isGateRelocation || selectedTask?.isALTPickUp) {
                let pickup = null;
                let dropoff = null;
                
                if (selectedTask?.pickUpLocation?.id) {
                    pickup = matchLocationById(pickUpLocations, selectedTask?.pickUpLocation?.id);
                }
                if (selectedTask?.dropOffLocation?.id) {
                    dropoff = matchLocationById(dropOffLocations, selectedTask?.dropOffLocation?.id);
                }
                
                if (pickup) {
                    props.setSelectedPickUp(pickup?._id);
                } else {
                    props.setSelectedPickUp(null);
                }
                if (dropoff) {
                    props.setSelectedDropOff(dropoff?._id);
                } else {
                    props.setSelectedDropOff(null);
                }
            } else {
                props.setSelectedPickUp(null);
                props.setSelectedDropOff(null);
            }
        }
    }, [flightDoc, selectedTask, pickUpLocations, dropOffLocations])

    const matchLocationByGateOrStand = (locations, gate, stand) => {
        let foundLocation = null;

        foundLocation = locations?.find(loc => (loc?.gate && loc?.gate?.trim() == gate?.trim()));
        if (Object.isObjectEmpty(foundLocation)) {
            foundLocation = locations?.find(loc => (loc?.stand && loc?.stand?.trim() == stand?.trim()));
        };
        return foundLocation;
    };

    const matchLocationById = (locations, locationId) => {
        return locations?.find(loc => loc?._id == locationId);
    }

    const formatSelectValue = (type, id) => {
        if (type == "pickUp") {
            // return pickUpLocations?.find(loc => loc?._id == id);
            let tempPickUp = pickUpLocations?.find(loc => loc?._id == id);
            if (tempPickUp) {
                return {
                    value: tempPickUp?._id,
                    label: tempPickUp?.title
                }
            } else {
                return null;
            }
        } else if (type == "dropOff") {
            // return dropOffLocations?.find(loc => loc?._id == id);
            let tempDropOff = dropOffLocations?.find(loc => loc?._id == id);
            if (tempDropOff) {
                return {
                    value: tempDropOff?._id,
                    label: tempDropOff?.title
                }
            } else {
                return null;
            }
        }
    }

    const getSelectStyles = () => ({
        control: (provided, state) => ({
            ...provided,
            minWidth: "25%",
            borderRadius: "5px",
            backgroundColor: usedTheme.BACKGROUND_COLOR,
            borderColor: usedTheme.BORDER_COLOR,
            color: usedTheme.TEXT_COLOR,
            boxShadow: state.isFocused ? `0 0 0 1px ${usedTheme.BORDER_COLOR}` : 'none',
            '&:hover': {
                borderColor: usedTheme.BORDER_COLOR,
            },
        }),
        placeholder: (provided) => ({
            ...provided,
            color: usedTheme.TEXT_COLOR,
        }),
        singleValue: (provided) => ({
            ...provided,
            color: usedTheme.TEXT_COLOR,
        }),
        menu: (provided) => ({
            ...provided,
            backgroundColor: usedTheme.BACKGROUND_COLOR,
            border: `1px solid ${usedTheme.BORDER_COLOR}`,
            zIndex: 5,
        }),
        option: (provided, state) => ({
            ...provided,
            backgroundColor: state.isFocused
                ? usedTheme.BORDER_COLOR
                : usedTheme.BACKGROUND_COLOR,
            color: usedTheme.TEXT_COLOR,
            cursor: 'pointer',
        }),
        input: (provided) => ({
            ...provided,
            color: usedTheme.TEXT_COLOR,
        }),
    });


    return (
        <Row>

            {/* select pick up + drop off location */}
            <Col xs={12} md={6} lg={6}>
                <div>
                    <Subtitle>Pick Up Location</Subtitle>
                    <Select
                        value={formatSelectValue("pickUp", props.selectedPickUp)}
                        onChange={(selectedOption) => props.setSelectedPickUp(selectedOption?.value)}
                        options={pickUpLocations?.map(loc => ({ value: loc._id, label: loc.title }))}
                        placeholder="Choose Pick Up Location..."
                        isClearable
                        styles={getSelectStyles()}
                    />

                </div>
            </Col>
            <Col xs={12} md={6} lg={6} >
                <div>
                    <Subtitle>Drop Off Location</Subtitle>
                    <Select
                        value={formatSelectValue("dropOff", props.selectedDropOff)}
                        onChange={(selectedOption) => props.setSelectedDropOff(selectedOption?.value)}
                        options={dropOffLocations?.map(loc => ({ value: loc._id, label: loc.title }))}
                        placeholder="Choose Drop Off Location..."
                        styles={getSelectStyles()}
                        isClearable
                    />
                </div>
            </Col>

        </Row>
    );
};

export default PickupDropOffDropDowns;
